import React, { useEffect, useState } from 'react';
import { Grid, Chip, Typography, Stack, TextField, IconButton } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const TonoMensajeApoderado = () => {
    const { promptData, setPromptData } = useActividadesContext();
    const [tono, setTono] = useState('');
    const [textoTono, setTextoTono] = useState('Otro');
    const [esEditableTono, setEsEditableTono] = useState(false);

    const opcionesTono = ['Alegre/Entusiasta', 'Formal', 'Amable/Acogedor'];

    useEffect(() => {
        if (promptData.tono_mensaje) {
            setTono(promptData.tono_mensaje);
            if (!opcionesTono.includes(promptData.tono_mensaje)) {
                setTextoTono(promptData.tono_mensaje);
            }
        }
    }, [promptData.tono_mensaje]);

    const handleTonoClick = (nuevoTono) => {
        setTono(nuevoTono);
        setEsEditableTono(false);
        setPromptData((prev) => ({ ...prev, tono_mensaje: nuevoTono }));
    };

    const activarEdicionTono = () => {
        setEsEditableTono(true);
    };

    const handleCambioTextoTono = (event) => {
        setTextoTono(event.target.value);
    };

    const guardarCambioTono = () => {
        if (textoTono.trim() !== '') {
            setTono(textoTono);
            setEsEditableTono(false);
            setPromptData((prev) => ({ ...prev, tono_mensaje: textoTono }));
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Typography
                    id="modal-modal-title"
                    sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}
                >
                    Tono del Mensaje
                </Typography>
            </Grid>

            <Grid item display="flex" flexDirection="row">
                {opcionesTono.map((opcion) => (
                    <Grid item key={opcion}>
                        <Stack direction="row" spacing={5} sx={{ m: 1 }}>
                            <Chip
                                label={opcion}
                                onClick={() => handleTonoClick(opcion)}
                                variant="outlined"
                                sx={{
                                    width: 200,
                                    m: 3,
                                    fontFamily: 'montserrat',
                                    backgroundColor: tono === opcion ? '#336B87' : '#FFFFFF',
                                    color: tono === opcion ? '#FFFFFF' : '#209099',
                                    borderColor: tono === opcion ? 'transparent' : '#336B87',
                                    borderWidth: '2px',
                                    ':hover': {
                                        backgroundColor: tono === opcion ? '#1e7888' : '#f5f5f5',
                                        borderColor: '#209099',
                                        color: '#209099'
                                    }
                                }}
                            />
                        </Stack>
                    </Grid>
                ))}
            </Grid>

            <Grid item key="otro" display="flex" flexDirection="row" xs={12} sm={12} md={6} lg={4} xl={3}>
                {esEditableTono ? (
                    <TextField
                        fullWidth
                        variant="outlined"
                        value={textoTono}
                        onChange={handleCambioTextoTono}
                        onBlur={guardarCambioTono}
                        InputProps={{
                            sx: {
                                borderRadius: 2
                            },
                            endAdornment: (
                                <IconButton onClick={guardarCambioTono}>
                                    <SaveIcon />
                                </IconButton>
                            )
                        }}
                        autoFocus
                    />
                ) : (
                    <Stack direction="row" spacing={2} sx={{ m: 1, ml: 0 }}>
                        <Chip
                            label={tono === textoTono ? textoTono : 'Otro'}
                            onClick={activarEdicionTono}
                            variant="outlined"
                            sx={{
                                width: 200,
                                m: 3,
                                backgroundColor: tono === textoTono ? '#336B87' : '#FFFFFF',
                                color: tono === textoTono ? '#FFFFFF' : '#209099',
                                borderColor: tono === textoTono ? 'transparent' : '#336B87',
                                borderWidth: '2px',
                                ':hover': {
                                    backgroundColor: tono === textoTono ? '#1e7888' : '#f5f5f5',
                                    borderColor: '#209099',
                                    color: '#209099'
                                },
                                fontFamily: 'Inter'
                            }}
                        />
                    </Stack>
                )}
            </Grid>
        </Grid>
    );
};

export default TonoMensajeApoderado;
